/**
 * Path for the Work IDs list page. Used for returnUrl when drilling to Routine/QP task pages.
 */
export const WORK_IDS_PATH = '/work-ids';

/**
 * Builds the URL for the Routine Work page with optional taskId and returnUrl for drill-back.
 */
export function routineWorkTaskUrl(taskId: number, returnToWorkIds = false): string {
  const params = new URLSearchParams();
  params.set('taskId', String(taskId));
  if (returnToWorkIds) params.set('returnUrl', WORK_IDS_PATH);
  return `/tasks/routine?${params.toString()}`;
}

/**
 * Builds the URL for the Quantified Work (QP Tracking) page with optional taskId and returnUrl for drill-back.
 */
export function qpTrackingTaskUrl(taskId: number, returnToWorkIds = false): string {
  const params = new URLSearchParams();
  params.set('taskId', String(taskId));
  if (returnToWorkIds) params.set('returnUrl', WORK_IDS_PATH);
  return `/tasks/quantified?${params.toString()}`;
}

/**
 * Builds the URL for the All Tasks page with optional taskId for drill-in modal.
 */
export function allTasksTaskUrl(taskId: number): string {
  const params = new URLSearchParams();
  params.set('taskId', String(taskId));
  return `/tasks/all?${params.toString()}`;
}

/**
 * Returns the task page URL (Routine, Quantified, or All Tasks) for a linked task, with optional returnUrl.
 */
export function taskPageUrl(
  task: { id: number; type: string },
  returnToWorkIds = false
): string {
  if (task.type === 'Routine') return routineWorkTaskUrl(task.id, returnToWorkIds);
  if (task.type === 'Quantified') return qpTrackingTaskUrl(task.id, returnToWorkIds);
  return allTasksTaskUrl(task.id);
}
